import { CreditApi } from "queries/Credit";
import PanelSegmentType from "components/panels/PanelSegment/PanelSegment";
import React from "react";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import { Loading } from "components/panels";
import { AddCreditModal } from "./AddCreditModal";

interface Props {
  clientId: number;
}

export const CreditPanel = (props: Props) => {
  const [displayAddCreditModal, setDisplayAddCreditModal] = React.useState(false);
  const creditsApi = CreditApi.GetCreditAccountByClient.useQuery({ clientId: props.clientId }, {});

  return <SectionPanel.Panel
    header={<>
      <PanelSegmentType.Title title={"Credits"} />
      <PanelSegmentType.Button onClick={() => setDisplayAddCreditModal(true)} label={RESX.Buttons.btnNew} type="secondary" />
    </>}
  >
    <div className="ui message purple">
      {(creditsApi.data?.data.balance.amount) ?? <Loading />}
      {(creditsApi.data != null) && <> credits left</>}
    </div>

    {displayAddCreditModal && <AddCreditModal clientId={props.clientId} onClose={() => setDisplayAddCreditModal(false)} />}
  </SectionPanel.Panel>
}